import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeCloseAiChat = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("close_ai_chat", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeCloseAiChat = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("close_ai_chat", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
